import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY, Observable } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';
import { LoaderService } from '../../shared/components/loader/loader.service';
import { ConfirmComponent } from '../../shared/components/confirm-generic/confirm.component';

export const deleteInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loaderSvc = inject(LoaderService);
  if (req.method === 'DELETE') {
    const dialog = inject(MatDialog);
    const confirmRef = dialog.open(ConfirmComponent, {
      data: {
        title: 'Confirm deletion',
        message: 'Are you sure you want to delete this record?',
      },
    });
    return confirmRef.afterClosed().pipe(
      switchMap((confirmed: boolean) => {
        if (confirmed) {
          loaderSvc.show();
          return next(req).pipe(finalize(() => loaderSvc.hide()));
        } else {
          return EMPTY;
        }
      })
    );
  }
  return next(req);
};
